import React, { Component } from 'react';
import { Table } from 'reactstrap';
import i18n from '../../../../i18next';

import {
    transformProductPrice,
    getPriceWithCurrencySymbol,
    calculateDiscount
} from '../../../../utils/CommonUtils';

class OrderDetailsTable extends Component {

    render() {
        const { discountTh } = this.props.styles;
        const { order } = this.props.orderDetails;
        let vat;

        vat = order.totalTax ? order.totalTax : 0;

        const acceptedTimeStyle = { padding: '18px 2px', paddingLeft: 12 };
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const orderServiceFee = order.serviceFee ? order.serviceFee : 0;
        const totalPrice = transformProductPrice(parseFloat(order.total) + orderServiceFee);
        const totalPriceWithCurrency = getPriceWithCurrencySymbol(totalPrice, currency);
        const vatPrice = transformProductPrice(vat);
        const vatPriceWithCurrency = getPriceWithCurrencySymbol(vatPrice, currency);
        const tipPrice = getPriceWithCurrencySymbol(order.tip, currency);

        let discountPrice = order.discount ? transformProductPrice(order.discount) : order.externalDiscountAmount ? transformProductPrice(order.externalDiscountAmount) : order.internalDiscountAmount ? transformProductPrice(order.internalDiscountAmount) : 0;

        let discountPriceWithCurrency = '';
        if (currency !== 'bgn' && discountPrice < 0) {
            discountPrice = discountPrice * -1;
            discountPriceWithCurrency = `-${getPriceWithCurrencySymbol(discountPrice, currency)}`;
        } else {
            discountPriceWithCurrency = getPriceWithCurrencySymbol(discountPrice, currency);
        }

        return (
            <Table responsive style={{minWidth: '1000px'}}>
                <thead>
                    <tr className="d-flex">
                        <th className="col-2">{i18n.t('screens:orderDetailsScreen.totalPrice')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.vat')}</th>
                        <th className='col-1'>{i18n.t('screens:orderDetailsScreen.deposit')}</th>
                        <th className={(!order.giftCardDiscount && !order.serviceFee && !order.deliveryCharge) ? 'col-2' : 'col-1'} style={discountTh}>{order.paidWithVoucher ?
                            i18n.t('screens:restaurantsMainContainer.loyalty')
                            :
                            i18n.t('screens:orderDetailsScreen.discountPrice')}
                        </th>
                        <th className={(!order.giftCardDiscount && !order.serviceFee && !order.deliveryCharge) ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.tip')}</th>
                        {
                            order.serviceFee ?
                                <th className={(!order.deliveryCharge && !order.giftCardDiscount) ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.fee')}</th> : null
                        }
                        {
                            order.giftCardDiscount ?
                            <th className={(!order.deliveryCharge && !order.serviceFee) ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.giftCard')}</th> : null
                        }
                        {
                            order.deliveryCharge ?
                                <th className={(!order.giftCardDiscount && !order.serviceFee) ? 'col-2' : 'col-1'}>{i18n.t('screens:orderDetailsScreen.deliveryCharge')}</th> : null
                        }
                        <th className={!order.serviceFee && !order.deliveryCharge ? 'col-2' : "col-2"}>{i18n.t('screens:orderDetailsScreen.placedTime')}</th>
                        <th className={!order.serviceFee && !order.deliveryCharge ? 'col-2' : "col-2"}>{i18n.t('screens:orderDetailsScreen.promisedTime')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="d-flex">
                        <td className="col-2">{totalPriceWithCurrency}</td>
                        <td className="col-1">{vatPriceWithCurrency}</td>
                        <td className='col-1'>{getPriceWithCurrencySymbol(transformProductPrice(order.orderDeposit), currency)}</td>
                        <td className={(!order.giftCardDiscount && !order.serviceFee && !order.deliveryCharge) ? 'col-2' : 'col-1'}>{discountPriceWithCurrency}</td>
                        <td className={(!order.giftCardDiscount && !order.serviceFee && !order.deliveryCharge) ? 'col-2' : 'col-1'}>{tipPrice}</td>
                        {
                            order.serviceFee ?
                                <td className={(!order.deliveryCharge && !order.giftCardDiscount) ? 'col-2' : 'col-1'}>{getPriceWithCurrencySymbol(transformProductPrice(order.serviceFee), currency)}</td> : null
                        }
                         {
                            order.giftCardDiscount ?
                                <td className={(!order.deliveryCharge && !order.serviceFee) ? 'col-2' : 'col-1'}>{`${getPriceWithCurrencySymbol(transformProductPrice(order.giftCardDiscount), currency)}`}</td> : null
                        }
                        {
                            order.deliveryCharge ?
                                <td className={(!order.giftCardDiscount && !order.serviceFee) ? 'col-2' : 'col-1'}>{getPriceWithCurrencySymbol(transformProductPrice(order.deliveryCharge), currency)}</td> : null
                        }
                        <td className={!order.serviceFee && !order.deliveryCharge ? 'col-2' : "col-2"} style={acceptedTimeStyle}>{order.placedTime}</td>
                        <td className={!order.serviceFee && !order.deliveryCharge ? 'col-2' : "col-2"} style={acceptedTimeStyle}>{(order.acceptedTime == null) ? (order.wantedTime == null) ? '------------' : order.wantedTime : order.acceptedTime}</td>
                    </tr>
                </tbody>
            </Table>
        )
    }
}

export default OrderDetailsTable;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/OrderDetailsTable.js